export default {
    "restore-all-materials": "إعادة تخزين كل المواد",
    "from-the-selected-medical-rep-to-your-account": "من المندوب الطبي المحدد إلى حسابك",
    "materials-summary": "ملخص المواد",
    "remaining-materials": "المواد المتبقية"
}